import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SupplyOrderAbout from './about/SupplyOrderAbout'
import SupplyOrderClient from './client/SupplyOrderClient'
import SupplyOrderComments from './comments/SupplyOrderComments'
import SupplyOrderBills from './bills/SupplyOrderBills'
import SupplyOrderApproval from './approval/SupplyOrderApproval'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { getSupplyOrderAPI } from '../../../../api/supply/supplyOrderAPI'
import ErrorMessage from '../../../UI/messages/ErrorMessage'
import SupplyOrderItems from './items/SupplyOrderItems'
import AddTabs from '../../../addTabs/AddTabs'
import { setSupplyOrder } from '../../../../store/supplyOrderSlice'

const SupplyOrderView = ({ supplyOrderId }) => {

    const supplyOrder = useSelector(state => state.supplyOrder.supplyOrder)
    const dispatch = useDispatch()
    // const [supplyOrder, setSupplyOrder] = useState('')

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        getSupplyOrder()
    }, [supplyOrderId])

    const getSupplyOrder = () => {
        setLoading(true)

        getSupplyOrderAPI({ supplyOrderId }).then(data => {
            // setSupplyOrder(data)
            dispatch(setSupplyOrder(data))
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }
    

  return (
    <div className='supplyOrderView'>
        <ErrorMessage error={error} />
        {
            !error ?
                <>
                    <div className='supplyOrderView__left'>
                        <div className='supplyOrderView__top'>
                            <SupplyOrderAbout 
                                supplyOrder={supplyOrder}
                            />
                            <SupplyOrderClient 
                                supplyOrderId={supplyOrderId}
                                // client={supplyOrder.client}
                                // user={supplyOrder.user}
                                // department={supplyOrder.department}
                            />
                            {/* <SupplyOrderApproval /> */}
                            {/* <SupplyOrderComments /> */}
                        </div>
                        <SupplyOrderItems 
                            supplyOrderId={supplyOrderId}
                            // supplyOrderItems={supplyOrder.items}
                        />
                        <SupplyOrderBills 
                            supplyOrderId={supplyOrderId}
                            // supplyOrderBills={sup}
                        />
                    </div>
                    <div className='supplyOrderView__right'>
                        <AddTabs 
                            comments={supplyOrder.comments}
                            changes={supplyOrder.changes}
                            supplyOrderId={supplyOrderId}
                        />
                    </div>
                </>
            : ''
        }
    </div>
  )
}

export default SupplyOrderView